import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';

function client() {
    const token = localStorage.getItem('token');
    return axios.create({
        baseURL: getApiBaseUrl(),
        headers: { Authorization: `Bearer ${token}` }
    });
}

export async function requestEmailVerify(email) {
    const res = await client().post('/auth/email/request-verify', { email });
    return res.data;
}

export async function confirmEmail(email, code) {
    const res = await client().post('/auth/email/confirm', { email, code });
    return res.data;
}
